<template>
  <div class="list row">
    <!-- <div class="col-md-8">
      <div class="input-group mb-3">
        <input type="text" class="form-control" placeholder="Søk etter stevnenavn"
          v-model="title"/>
        <div class="input-group-append">
          <button class="btn btn-outline-secondary" type="button"
            @click="searchTitle"
          >
            Søk
          </button>
        </div>
        
      </div>
    </div> -->
    <div class="col-md-6">
      <h4>Stevner</h4>
      <ul class="list-group">
        <li class="list-group-item"
          :class="{ active: index == currentIndex, 'bg-success': competition.adminApproved}"
          v-for="(competition, index) in competitions"
          :key="index"
          @click="setActiveCompetition(competition, index)"
        >
          {{ competition.name }} ({{ competition.date_start | formatDate_onlyDate }} - {{ competition.date_end | formatDate_onlyDate }})
        </li>
      </ul>

      <!-- <button class="m-3 btn btn-sm btn-danger" @click="removeAllCompetitions">
        Remove All
      </button> -->
    </div>
    <div class="col-md-6">
      <div v-if="currentCompetition">
        <!-- <Competition competition_id=currentCompetition.id></Competition> -->
        <h4>Stevne</h4>
        <div>
          <label><strong>Navn:</strong></label> {{ currentCompetition.name || "NoName"}}
        </div>
        <div>
          <label><strong>Stevnenummer:</strong></label> {{ currentCompetition.id }}
        </div>
        <div v-if="currentCompetition.hash">
          <label><strong>Stevnekode:</strong></label> {{ currentCompetition.hash }}
        </div>
        <div>
          <label><strong>Dato:</strong></label> {{ currentCompetition.date_start | formatDate_onlyDate}} - {{ currentCompetition.date_end | formatDate_onlyDate}}
        </div>
        <div>
          <label><strong>Nivå:</strong></label> {{ currentCompetition.level }}
        </div>
        <div>
          <label><strong>Arrangør:</strong></label> {{ currentCompetition.organizer }}
        </div>
        <div>
          <label><strong>Web:</strong></label> {{ currentCompetition.external_webpage }}
        </div>
        <div>
          <label><strong>Stadion:</strong></label> {{ currentCompetition.venue_id }}
        </div>
        <div>
          <label><strong>Tilhørighet:</strong></label> {{ currentCompetition.affiliation && currentCompetition.affiliation.field }} = {{ currentCompetition.affiliation && currentCompetition.affiliation.title }}
        </div>
        <div>
          <label><strong>Publiseringsdato:</strong></label> {{ currentCompetition.publishDate | formatDate_onlyDate }}
        </div>
        <div>
          <label><strong>Skjul m. opprop etter resultat:</strong></label> {{ currentCompetition.hideMissingCallroomAfterFirstResult ? "Valgt" : "Ikke valgt" }}
        </div>
        <div>
          <label><strong>Admin godkjennelse:</strong></label> {{ currentCompetition.adminApproved ? "Godkjent" : "Venter" }}
        </div>
        <div>
          <router-link :to="'/callroom/upload/'+ currentCompetition.id +'/'+ currentCompetition.hash">Last opp oppropsdata fra Frisys</router-link>
        </div>
        <div>
          <a
          :href=link_data_url(currentCompetition)
          v-text=link_data_label(currentCompetition)
          @click.prevent="downloadCompetitionFile({
            url: link_data_url(currentCompetition), 
            label: link_data_label(currentCompetition)
          })"></a><br>
        </div>
        <div>
          <a
          :href=link_data_url2(currentCompetition)
          v-text=link_data_label2(currentCompetition)
          @click.prevent="downloadCompetitionFile({
            url: link_data_url2(currentCompetition), 
            label: link_data_label2(currentCompetition)
          })"></a><br>
        </div>

        <a v-if="checkRole('frisys_admin')" class="badge badge-warning"
          :href="'/competition/'+currentCompetition.id+'/edit'"
        >
          Edit
        </a>
        <div v-else>
          Ved behov for endringer: kontakt Andro
        </div>
      </div>
      <div v-else>
        <br />
        <p>Stevneinfo...</p>
      </div>
    </div>
  </div>
</template>

<script>
import CompetitionDataService from "../services/CompetitionDataService";
// import Competition from "./Competition.vue";

// TODO: Replace Competition with the actual Competition component

export default {
  name: "competitions-list",
  components: {
    // Competition
  },
  data() {
    return {
      competitions: [],
      currentCompetition: null,
      currentIndex: -1,
      title: ""
    };
  },
  methods: {
    retrieveCompetitions() {
      CompetitionDataService.getAll()
        .then(response => {
          this.competitions = response.data;
          console.log(response.data);
          // this.items.sort((a, b) => a.price - b.price);
          this.competitions = response.data.competitions.sort((a,b) => b.id - a.id);
        })
        .catch(e => {
          console.log(e);
        });
    },
    downloadCompetitionFile ({ url, label }) {
      CompetitionDataService.getCompetitionFile({url, label});
    },
    link_data_url(currentCompetition) {
      return "/api/competition/download/"+ currentCompetition.id + "/" + currentCompetition.hash;
    },
    link_data_url2(currentCompetition) {
      return "/api/competition/download/"+ currentCompetition.id + "/" + currentCompetition.hash + "/events";
    },
    link_data_label(currentCompetition) {
      return "frisys_competition_"+ currentCompetition.id + ".json";
    },
    link_data_label2(currentCompetition) {
      return "frisys_events_"+ currentCompetition.id + ".json";
    },

    refreshList() {
      this.retrieveCompetitions();
      this.currentCompetition = null;
      this.currentIndex = -1;
    },

    setActiveCompetition(competition, index) {
      this.currentCompetition = competition;
      this.currentIndex = index;
    },

    removeAllCompetitions() {
      CompetitionDataService.deleteAll()
        .then(response => {
          console.log(response.data);
          this.refreshList();
        })
        .catch(e => {
          console.log(e);
        });
    },
    
    searchTitle() {
      CompetitionDataService.findByTitle(this.title)
        .then(response => {
          this.competitions = response.data;
          console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
  filters: {
    formatDate_onlyDate(value) {
      const date = new Date(value);
      return date.toLocaleDateString("no-NO", { year: 'numeric', month: 'numeric', day: 'numeric' });
    }
  },
  mounted() {
    this.retrieveCompetitions();
  }
};
</script>

<style>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}
</style>
